import { Button, ButtonProps } from "@chakra-ui/react";
import React from "react";

const PrimaryButton: React.FC<ButtonProps> = ({ children, ...props }) => {
  const { isDisabled } = props;
  return (
    <Button
      isDisabled={isDisabled}
      justifySelf="center"
      width="168px"
      colorScheme="blue"
      variant="solid"
      bgColor="brand.800"
      fontFamily="Calibri (Body)"
      fontSize="16px"
      fontWeight="normal"
      {...props}
    >
      {children}
    </Button>
  );
};
export default PrimaryButton;
